import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        departments: []
    },
  
    getters: {
        loadInProgress (state) {
            return state.loading;
        },
        getDepartments (state) {
            return state.departments;
        }
    },
  
    mutations: {
        setDepartments (state, data) {
            state.departments = data;
        },
        loading (state) {
            state.loading = true;
            state.loadError = "";
        },
        loaded (state) {
            state.loading = false;
        },
        loadError (state, err) {
            state.departments = [];
            state.loadError = err;
        }
    },
  
    actions: {
        loadDepartments (context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchDepartments({
                    success: function(response) {
                        context.commit("setDepartments", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loaded");
                    }
                });
            });
        }
    }
}
